import axios, { AxiosInstance } from "axios";
import { PluginFunction } from "vue";

declare module "vue/types/vue" {
  // Add the $axios property on every vue instance.
  interface Vue {
    $axios: AxiosInstance;
  }
}

const plugin: PluginFunction<undefined> = Vue => {
  Vue.prototype.$axios = axios.create({});
};

export default plugin;
